module.exports = __webpack_public_path__ + "img/2.3f0aa146.jpg";